import { gql } from "lib/apolloClient";
import { notificationListNodeV2Fragment } from "./NotificationCenterV2Fragments";

export const getNotificationsV2Query = gql`
  query getNotificationsV2(
    $id: ID!
    $after: String
    $type: ENTITY_TYPE_ENUM!
    $filters: NotificationFilters
    $notificationCategoryFilter: [NOTIFICATION_CATEGORY_ENUM!]
  ) {
    node(id: $id, type: $type) {
      id
      ... on Staff {
        ...staffItem
      }
      ... on Student {
        ...studentItem
      }
      ... on FamilyMember {
        ...parentItem
      }
    }
  }
  ${notificationListNodeV2Fragment.staff}
  ${notificationListNodeV2Fragment.student}
  ${notificationListNodeV2Fragment.parent}
`;
